import React, { useCallback, useState, useEffect } from "react";
import AudioPlayer from "../audio-player";
import './style.scss';

export default function AudioQuiz() {

    const DATA = [
        {
            audio: '/sounds/niedzwiedz.mp3',
            correct: 'niedźwiedź',
            answers: ['dzik', 'niedźwiedź', 'lew']
        },
        {
            audio: '/sounds/sowa.mp3',
            correct: 'sowa',
            answers: ['sowa', 'kukułka', 'bocian']
        },
        {
            audio: '/sounds/wilk.mp3',
            correct: 'wilk',
            answers: ['wilk', 'jenot', 'lis']
        },
        {
            audio: '/sounds/orzel.mp3',
            correct: 'orzeł',
            answers: ['myszołów', 'orzeł', 'krogulec']
        },
        {
            audio: '/sounds/wiewiorka.wav',
            correct: 'wiewiórka',
            answers: ['chomik', 'szpak', 'wiewiórka']
        },
        {
            audio: '/sounds/jastrzab.mp3',
            correct: 'jastrząb',
            answers: ['mewa', 'pustułka', 'jastrząb']
        }
    ]

    const correctChangeHandler = useCallback((state: boolean) => {
    }, [])

    return (
        <div className="audio-test">
            {DATA.map((d, index) => {
                return (
                    <Question
                        key={index}
                        audio={d.audio}
                        answers={d.answers}
                        correct={d.correct}
                        correctChangeHandler={correctChangeHandler}
                    />
                )
            })}
        </div>
    )
}


type QProps = {
    audio: string,
    answers: string[],
    correct: string,
    correctChangeHandler: (state: boolean) => void
}

const Question: React.FunctionComponent<QProps> = ({ audio, answers, correct, correctChangeHandler }) => {

    const [isCorrect, setIsCorrect] = useState(false);
    const [selected, setSelected] = useState<string>('');

    const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setSelected(e.currentTarget.value);
        setIsCorrect((e.currentTarget.value === correct));
    }, [correct])

    useEffect(() => {
        correctChangeHandler(isCorrect)
    }, [isCorrect, correctChangeHandler])

    return (
        <div className={`question ${isCorrect ? 'correct' : ''}`}>

            <AudioPlayer
                src={audio}
            />

            <div className="answers">
                {
                    answers.map((a, index) => {
                        return (
                            <label
                                key={index}
                                className={`answer ${correct === a ? 'correct' : ''} ${selected === a ? 'selected' : ''}`}
                                tabIndex={0}
                            >
                                <input
                                    type="radio"
                                    name={`q_${correct}`}
                                    value={a}
                                    onChange={onChange}
                                /> {a}
                            </label>)
                    })
                }
            </div>
        </div>
    )

}
